module.exports = __webpack_public_path__ + "img/cloudflare.62a182be.png";